import { StatusBadge } from "@/components/StatusBadge";

const STATE = {
  livrat: { type: "delivered", label: "Livrare confirmată" },
  retur: { type: "notdelivered", label: "Retur" },
  netrimis: { type: "neutral", label: "Netrimisă" },
  in_tranzit: { type: "unpaid", label: "În curs de livrare" },
};

export default function ResultsTable({ awbs }) {
  if (!awbs?.length)
    return (
      <div className="text-sm text-muted-foreground font-mono py-10 text-center">Niciun AWB de afișat</div>
    );

  return (
    <div className="border border-border rounded-sm overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm font-mono">
          <thead className="bg-[#0c0c0e] sticky top-0">
            <tr className="text-left text-muted-foreground text-xs uppercase tracking-wider">
              <th className="px-4 py-3 font-medium">AWB</th>
              <th className="px-4 py-3 font-medium">Fișier</th>
              <th className="px-4 py-3 font-medium">Livrare</th>
              <th className="px-4 py-3 font-medium">Status curier</th>
              <th className="px-4 py-3 font-medium">Data livrare</th>
              <th className="px-4 py-3 font-medium">Plată</th>
              <th className="px-4 py-3 font-medium text-right">Sumă ramburs</th>
            </tr>
          </thead>
          <tbody>
            {awbs.map((a) => {
              const st = STATE[a.delivery_state] || STATE.netrimis;
              return (
                <tr
                  key={a.awb}
                  data-testid={`row-${a.awb}`}
                  className="border-t border-border hover:bg-muted/30 transition-colors"
                >
                  <td className="px-4 py-3 font-medium">{a.awb}</td>
                  <td className="px-4 py-3 text-muted-foreground max-w-[180px] truncate" title={a.source}>
                    {a.source || "—"}
                  </td>
                  <td className="px-4 py-3">
                    <StatusBadge type={st.type}>{st.label}</StatusBadge>
                  </td>
                  <td className="px-4 py-3 text-muted-foreground max-w-[240px] truncate" title={a.last_status}>
                    {a.last_status}
                  </td>
                  <td className="px-4 py-3 text-muted-foreground">{a.delivery_date || "—"}</td>
                  <td className="px-4 py-3">
                    {a.paid === null || a.paid === undefined ? (
                      <StatusBadge type="neutral">Neverificat</StatusBadge>
                    ) : a.paid ? (
                      <StatusBadge type="paid">Plătit</StatusBadge>
                    ) : (
                      <StatusBadge type="unpaid">Neplătit</StatusBadge>
                    )}
                  </td>
                  <td className="px-4 py-3 text-right">{a.amount ? `${a.amount}` : "—"}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
